export default __webpack_public_path__ + "static/media/choco-combo.4c573d98.png";